(function () {
    'use strict';
    angular.module('app').controller('AccountingShipmentDetailsController', AccountingShipmentDetailsController);
    AccountingShipmentDetailsController.$inject = [
        'AccountingService',
        'Shipments',
        '$routeParams',
        'toastr',
        'InvoicedShipmentAuditTrailTable',
        'scrollToForm',
        '$q',
        '$location',
        'ConfirmationModalFactory',
        '$rootScope',
        '$timeout',
        '$window',
        'FormHelpersService',
        'CommonService'
    ];

    function AccountingShipmentDetailsController(
        AccountingService,
        Shipments,
        $routeParams,
        toastr,
        InvoicedShipmentAuditTrailTable,
        scrollToForm,
        $q,
        $location,
        ConfirmationModalFactory,
        $rootScope,
        $timeout,
        $window,
        FormHelpersService,
        CommonService
    ) {
        const vm = this;
        vm.onUpdateButtonClicked = onUpdateButtonClicked;
        vm.onApproveForBillingClicked = onApproveForBillingClicked;
        vm.onBackButtonClicked = onBackButtonClicked;
        vm.downloadReceipt = downloadReceipt;
        vm.archiveShipments = archiveShipments;

        const shipmentId = $routeParams.shipmentId;
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const updateConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.updateInvoiceShipment.MESSAGE',
            code: 'messages.warning.updateInvoiceShipment.CODE'
        });

        const unreconcileConfirmation = new ConfirmationModalFactory({}, {
            message: 'This shipment is unreconciled.',
            code: 'messages.warning.updateInvoiceShipment.CODE'
        });
        const onRouteChangeOff = $rootScope.$on('$routeChangeStart', routeChangeHandler);

        const viewConfirmationArchive = new ConfirmationModalFactory({}, {
            message: 'messages.warning.archive.MESSAGE',
            code: 'messages.warning.archive.CODE',
        });

        function archiveShipments() {
            vm.archivebilling = true;
            const shipmentId = [];
            shipmentId.push(vm.invoicedShipmentData.id)
            viewConfirmationArchive.getInstance().result.then(function (cond) {
                if (cond) {
                    Shipments.archiveShipments(shipmentId, () => {
                        toastr.success('Shipment archived successfully');
                        vm.archivebilling = false
                    }, () => {
                        toastr.error('Unable to archive shipment.', 'Please try again later');
                        vm.archivebilling = false;
                    });
                }
            });
        }

        function redirectToNextPath(path, next) {
            switch (path) {
                case '/accounting/customer-billing/:id' :
                    $location.path(path.replace(':id', next.params.id));
                    break;
                case '/accounting/invoices/:id' :
                    $location.path(path.replace('id', vm.invoicedShipmentData.invoiceId));
                    break;
                default:
                    $location.path(path);
                    break;
            }
        }

        function showLeavingPageConfirmationMessage(path, next) {
            viewConfirmation.getInstance().result.then(cond => {
                if (cond) {
                    onRouteChangeOff();
                    redirectToNextPath(path, next);
                }
            });
        }

        function checkIfThereAreDataChanges(sanitizedInvoiceShipmentData, sanitizedOriginalInvoicedShipmentData, routeObj) {
            if (!angular.equals(sanitizedInvoiceShipmentData, sanitizedOriginalInvoicedShipmentData)) {
                routeObj.event.preventDefault();
                showLeavingPageConfirmationMessage(routeObj.path, routeObj.next);
            }
        }

        function routeChangeHandler(event, next, current) {
            const path = next.$$route.originalPath;
            checkIfThereAreDataChanges(
                getPayload(vm.invoicedShipmentData),
                getPayload(vm.originalInvoicedShipmentData),
                {
                    event: event,
                    path: path,
                    next: next
                }
            );
        }

        function updateAuditTrailTableData(shipmentData) {
            vm.invoicedShipmentAuditTrailTable.updateTableData(shipmentData.history);
        }

        function updateSuccess(shipmentData) {
            setInvoicedShipmentData(shipmentData);
            updateAuditTrailTableData(shipmentData);
            setOriginalDataCopy();
            toastr.success('Success', 'Invoiced Shipment Data Updated');
        }

        function updateFailed(error) {
            toastr.error('Error', error.message);
        }

        function toggleUpdatingIndicator(status) {
            vm.updatingInvoicedShipmentData = status;
        }

        function updateUnreconciledShipment(payload) {
            toggleUpdatingIndicator(true);
            AccountingService.Invoices.updateUnreconciledShipment(data => {

                getShipmentData().then((shipmentData) => {
                    updateSuccess(shipmentData);
                    toggleUpdatingIndicator(false);
                });
            }, error => {
                updateFailed(error);
                toggleUpdatingIndicator(false);
            }, shipmentId, payload);
        }

        function updateInvoicedShipment(payload) {
            toggleUpdatingIndicator(true)
            AccountingService.Invoices.udpateInvoiceShipment(data => {
                getShipmentData().then((shipmentData) => {
                    updateSuccess(shipmentData);
                    toggleUpdatingIndicator(false)
                });
            }, error => {
                updateFailed(error);
                toggleUpdatingIndicator(false)
            }, vm.invoicedShipmentData.invoiceId, shipmentId, payload);
        }

        function validateForms(forms) {
            FormHelpersService.setFormsToSubmitted(forms);
            return FormHelpersService.getInvalidForms(forms);
        }

        function isShipmentInvoiced() {
            return vm.invoicedShipmentData.invoiceId !== null;
        }

        function saveShipmentDetailsData(forms) {
            const invalidForms = validateForms(forms);
            if (invalidForms.length !== 0) { return false; }
            if (isShipmentInvoiced()) {
                updateInvoicedShipment(getPayload(vm.invoicedShipmentData));
            } else {
                updateUnreconciledShipment(getPayload(vm.invoicedShipmentData));
            }
        }

        function showUpdateConfirmation(forms) {
            updateConfirmation.getInstance().result.then(cond => {
                if (cond) {
                    saveShipmentDetailsData(forms);
                }
            });
        }

        function onUpdateButtonClicked(...forms) {
            showUpdateConfirmation(forms);
        }

        function getPayload(invoicedShipmentDetailsData) {
            return {
                invoiceDetails: getInvoiceDetailsData(invoicedShipmentDetailsData.invoiceDetails),
                shippingCost: getShippingCostData(invoicedShipmentDetailsData.actualShippingCost, invoicedShipmentDetailsData.currency)
            }
        }

        function getInvoiceDetailsData(data) {
            return {
                account: data.account,
                invoiceDate: angular.isDefined(data.invoiceDate) ? data.invoiceDate : getCurrentDate,
                actualMargin: Number(data.actualMargin),
                actualMarginPercentage: Number(data.actualMarginPercentage),
                additionalCharges: Number(data.additionalCharges),
                chargeableWeight: Number(data.chargeableWeight),
                exTaxCharge: Number(data.exTaxCharge),
                exTaxTotal: Number(data.exTaxTotal),
                forProcessing: data.forProcessing,
                fuel: Number(data.fuel),
                internalNotes: data.internalNotes,
                invoiceNotes: data.invoiceNotes,
                reconciled: data.reconciled,
                surcharges: angular.isArray(data.surcharges) ? {} : data.surcharges,
                tax: Number(data.tax),
                weightUnit: data.weightUnit
            }
        }

        function getCurrentDate() {
            const today = new Date();
            const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
            const mm = today.getMonth() + 1 < 10 ? `0${today.getMonth()}` : today.getMonth();
            const yyyy = today.getFullYear();
            return `${yyyy}-${mm}-${dd}`;
        }

        function getAdditionalCharges(data) {
            return data.additionalCharges.map(charge => {
                return {
                    amount: angular.getObjVal(charge, 'amountValue.value') ? Number(charge.amountValue.value) : Number(charge.amount),
                    durationInSeconds: angular.getObjVal(charge, 'durationValue.value') ? charge.durationValue.value : charge.durationInSeconds,
                    name: charge.name,
                }
            });
        }

        function getShippingCostData(data, currency) {
            return {
                additionalCharges: getAdditionalCharges(data),
                otherSurchargeTotal: Number(data.otherSurchargeTotal),
                additionalCharges1: Number(data.additionalCharges1),
                additionalCharges2: Number(data.additionalCharges2),
                cost: Number(data.cost),
                currency: currency,
                driverCommissionFixed: Number(data.driverCommissionFixed),
                driverCommissionPercentage: Number(data.driverCommissionPercentage),
                driverCommissionPercentageValue: Number(data.driverCommissionPercentageValue),
                driverFee: Number(data.driverFee),
                duties: Number(data.duties),
                minPickupFee: Number(data.minPickupFee),
                percentFuel: Number(data.percentFuel),
                percentMargin: Number(data.percentMargin),
                percentValueFuel: Number(data.percentValueFuel),
                percentValueMargin: Number(data.percentValueMargin),
                pickupFeeEnabled: data.pickupFeeEnabled,
                sellPrice: Number(data.sellPrice),
                surchargeDetails: data.surchargeDetails,
                taxPercent: Number(data.taxPercent),
                taxes: Number(data.taxes),
                valueFuel: Number(data.valueFuel),
                valueMargin: Number(data.valueMargin),
                vat: Number(data.valueMargin)
            }
        }

        function approveInvoicedShipment() {
            vm.approvingForBilling = true;
            if(!vm.invoicedShipmentData.invoiceDetails.reconciled){
                unreconcileConfirmation.getInstance().result.then(cond => {
                    if (cond) {
                        approveUnreconciledInvoicedShipment();
                    }
                    vm.approvingForBilling = false;
                });
                return;
            }
            AccountingService.Invoices.reconcileByShipment(data => {
                vm.approvingForBilling = false;
                toastr.success("Success", "Shipment is now reconciled");
                loadShipmentDetailsData();
            }, error => {
                vm.approvingForBilling = false;
                toastr.error("Error", error.message);
            }, vm.invoicedShipmentData.invoiceId, [vm.invoicedShipmentData.id]);
        }

        function approveUnreconciledInvoicedShipment(){
            vm.approvingForBilling = true;
            AccountingService.Invoices.unreconcileByShipmentForceApproved(data => {
                vm.approvingForBilling = false;
                toastr.success("Success", "Shipment is now reconciled");
                onBackButtonClicked()

            }, error => {
                vm.approvingForBilling = false;
                toastr.error("Error", error.message);
            }, vm.invoicedShipmentData.invoiceId, [vm.invoicedShipmentData.id]);
        }

        function approveUnreconciledShipment() {
            vm.approvingForBilling = true;
            AccountingService.Invoices.approveUnreconciledShipments(success => {
                vm.approvingForBilling = false;
                loadShipmentDetailsData();
                toastr.success("Success", "Shipment is now reconciled");
            }, error => {
                vm.approvingForBilling = false;
                toastr.error("Error", error.message);
            }, [vm.invoicedShipmentData.id]);
        }

        function approveShipmentForBilling() {
            if (isShipmentInvoiced()) {
                approveInvoicedShipment();
            } else {
                approveUnreconciledShipment();
            }
        }

        function onApproveForBillingClicked() {
            approveShipmentForBilling();
        }

        function onBackButtonClicked() {
            $window.history.back();
        }

        function initializeInvoicedAuditTrailTableData() {
            vm.invoicedShipmentAuditTrailTable = new InvoicedShipmentAuditTrailTable(vm.invoicedShipmentData.history);
            vm.invoicedShipmentAuditTrailTableData = vm.invoicedShipmentAuditTrailTable.tableData;
        }

        function setShowApproveForBillingButton(status) {
            vm.showApproveForBillingButton = status
        }

        function setApproveForBillingButtonStatus() {
            if (angular.getObjVal(vm.invoicedShipmentData, 'invoiceDetails')) {
                setShowApproveForBillingButton(!vm.invoicedShipmentData.invoiceDetails.reconciled);
            } else {
                setShowApproveForBillingButton(true);
            }
        }

        function getShipmentData() {
            const defer = $q.defer();
            Shipments.getItem(shipmentId, data => {
                console.log(vm.invoiceDetails)
                defer.resolve(data);
            });
            return defer.promise;
        }

        function getBillingDetails() {
            const defer = $q.defer();
            AccountingService.CustomerBilling.getOne(data => {
                defer.resolve(data);
            }, error => {
                defer.reject(error);
            }, vm.invoicedShipmentData.invoiceId);
            return defer.promise;
        }

        function setOriginalDataCopy() {
            $timeout(() => {
                vm.originalInvoicedShipmentData = angular.copy(vm.invoicedShipmentData);
            }, 1000);
        }

        function setIsInvoiceNotesEnabled() {
            vm.isInvoiceNotesEnabled = !!vm.invoicedShipmentData.invoiceDetails;
        }

        function setInvoicedShipmentData(data) {
            vm.invoicedShipmentData = data;
        }

        function setPageToViewModeOrEditMode(data) {
            vm.isViewMode = data.emailedToCustomerDate ? true : false;
        }

        function toggleLoadingShipmentBillingData(loadingMessage, status){
            toggleLoadingIndicator(loadingMessage, status);
        }

        function setIsDomesticShipment(data) {
            vm.isDomestic = CommonService.isDomesticFn(data.sourceAddress, data.destinationAddress);
        }

        function loadShipmentBillingData() {
            toggleLoadingShipmentBillingData('Loading Shipment Billing Data', true);
            if (isShipmentInvoiced()) {
                getBillingDetails().then(data => {
                    setPageToViewModeOrEditMode(data);
                    toggleLoadingShipmentBillingData(false);
                }, error => {
                    toggleLoadingShipmentBillingData(false);
                });
            } else {
                toggleLoadingShipmentBillingData(false);
            }
        }

        function toggleLoadingIndicator(loadingMessage, status) {
            vm.loadingMessage = loadingMessage;
            vm.loadingShipmentData = status;
        }

        function toggleLoadingShipmentData(status, loadingMessage) {
            toggleLoadingIndicator(loadingMessage, status);
        }

        function loadShipmentDetailsData() {
            toggleLoadingShipmentData(true, 'Loading Shipment Details');
            getShipmentData().then(data => {
                toggleLoadingShipmentData(false);
                setInvoicedShipmentData(data);
                setIsInvoiceNotesEnabled();
                setApproveForBillingButtonStatus();
                initializeInvoicedAuditTrailTableData();
                loadShipmentBillingData();
                setOriginalDataCopy();
                setIsDomesticShipment(data);
            });
        }

        function downloadReceipt() {
            Shipments.downloadReceipt(success=> {
                toastr.success('Receipt downloaded', 'Success');
            }, error => {
                toastr.error('Failed to download invoice', 'Error');
            }, shipmentId);
        }

        function init() {
            loadShipmentDetailsData();
        }

        init();
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingShipmentDetailsController.js